import { useTranslation } from "react-i18next";

const WHATSAPP_NUMBER = "919601955070";

export default function WhatsAppButton({ message }) {
  const { t } = useTranslation();
  const text = message || t("whatsapp.message");
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-button"
      aria-label={t("whatsapp.aria")}
      className="group fixed bottom-5 right-5 z-50 flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-3 text-white shadow-lg shadow-emerald-600/30 transition-transform hover:scale-105 active:scale-95"
    >
      <svg viewBox="0 0 32 32" className="h-6 w-6 fill-current" aria-hidden="true">
        <path d="M16.003 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.256.59 4.46 1.71 6.402L3.2 28.8l6.59-1.727a12.74 12.74 0 006.213 1.583h.005c7.06 0 12.8-5.74 12.8-12.8 0-3.42-1.332-6.635-3.752-9.056A12.72 12.72 0 0016.003 3.2zm0 23.02h-.004a10.6 10.6 0 01-5.4-1.48l-.387-.23-4.01 1.052 1.07-3.91-.252-.4a10.57 10.57 0 01-1.62-5.65c0-5.86 4.77-10.63 10.64-10.63 2.84 0 5.51 1.108 7.52 3.118a10.56 10.56 0 013.114 7.52c0 5.865-4.77 10.635-10.63 10.635zm5.83-7.96c-.32-.16-1.89-.933-2.183-1.04-.293-.106-.507-.16-.72.16-.213.32-.826 1.04-1.013 1.253-.187.213-.373.24-.693.08-.32-.16-1.35-.498-2.57-1.586-.95-.847-1.59-1.893-1.777-2.213-.187-.32-.02-.493.14-.653.144-.143.32-.373.48-.56.16-.187.213-.32.32-.533.107-.213.053-.4-.027-.56-.08-.16-.72-1.734-.986-2.374-.26-.624-.524-.54-.72-.55l-.613-.01c-.213 0-.56.08-.853.4-.293.32-1.12 1.094-1.12 2.667 0 1.573 1.146 3.093 1.306 3.307.16.213 2.253 3.44 5.46 4.827.763.33 1.36.526 1.824.674.766.244 1.464.21 2.016.127.615-.092 1.89-.773 2.156-1.52.267-.746.267-1.386.187-1.52-.08-.133-.293-.213-.613-.373z"/>
      </svg>
      <span className="hidden text-sm font-semibold sm:inline">{t("whatsapp.label")}</span>
    </a>
  );
}
